import { Application } from '@/types/application';
import { Detail } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { isObject } from '@/util/typeGuards';

export const queueMessageUtil = (): ValidationObject<{ value: unknown; type: unknown } | undefined> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const value = getValue(configuration, details);
    if (configuration.required && value === undefined) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing required Queue message reference: ${configuration.label}`,
        id: nodeId
      });
    } else if (value !== undefined) {
      const foundQueue = application.queues
        ?.find((queue) => queue.queue === value.type)
        ?.messages?.find((message) => message === value.value);
      if (!foundQueue) {
        errors.push({
          severity: 'error',
          message: `Block ${blockName} refers to a Queue message that doesn't exist.`,
          id: nodeId
        });
      }
    }
    return errors;
  };

  const getValue = (configuration: Configuration, obj: unknown): { value: unknown; type: unknown } | undefined => {
    if (!obj) return;
    if (isObject(obj)) {
      if (configuration.subtype && obj[configuration.subtype]) {
        return {
          value: obj[configuration.value],
          type: obj[configuration.subtype]
        };
      }
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate: validate,
    getValue: getValue
  };
};
